import Alert from '@mui/material/Alert'
import { Controller, type FieldPath, type FieldValues, useFormContext } from 'react-hook-form'
import { Icon } from '../../../../components/Icon.tsx'
import type { BaseReportForm } from '../schema.ts'

export const FieldErrorAlert = <TForm extends FieldValues = BaseReportForm>({ name }: { name: NoInfer<FieldPath<TForm>> }) => {
	const { control } = useFormContext<TForm>()
	return (
		<Controller
			control={control}
			name={name}
			render={({ fieldState }) =>
				fieldState.error?.message ? (
					<Alert icon={<Icon name='CircleExclamation' />} severity='error'>
						{fieldState.error.message}
					</Alert>
				) : (
					<></>
				)
			}
		/>
	)
}
